// <!-- ============================================================================= -->
// <!-- Ella Custom JS - Customize The Style For Layout -->
// <!-- ============================================================================= -->

// <!-- ============================================================================= -->
// <!-- IMPORTANT DISCLAIMER -->
// <!-- Please use only JS to style the layout. -->
// <!-- ============================================================================= -->

// class ReviewSlider extends HTMLElement {
//   constructor() {
//     super();
//     const slideEle = this.querySelector('.review-slider');    
//     let slider = new Swiper(slideEle, {
//       slidesPerView: 1,
//       loop: true,
//       dots: true,
//       pagination: {
//         el: ".swiper-pagination",
//         clickable: true,
//       },
//       navigation: {
//         nextEl: ".swiper-button-next",
//         prevEl: ".swiper-button-prev",
//       },
//       spaceBetween: 0,        
//     });
//   }

//   connectedCallback() {    
    
//   }  
  
// }
// customElements.define('review-slider', ReviewSlider);


class ReviewSlider extends HTMLElement {
  constructor() {
    super();

    const slideEle = this.querySelector('.review-slider');
    const paginationEl = this.querySelector('.swiper-pagination');
    const nextBtn = this.querySelector('.swiper-button-next');
    const prevBtn = this.querySelector('.swiper-button-prev');

    new Swiper(slideEle, {
      slidesPerView: 1,
      loop: true,
      spaceBetween: 0,
      pagination: {
        el: paginationEl,
        clickable: true,
      },
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
    });
  }

  connectedCallback() {}
}

customElements.define('review-slider', ReviewSlider);

document.addEventListener("DOMContentLoaded", () => {
  // Initialize price per gram calculation using global function if available
  function initializePricePerGram() {
    if (window.updatePricePerGram) {
      window.updatePricePerGram();
    } else {
      // Fallback to original logic if global function is not available
      document.querySelectorAll(".meta_connected_prd").forEach(v => {
        let vp = parseFloat(v.querySelector(".prod_var_price").textContent.trim()),
            gp = v.querySelector(".prod_price_gram"),
            ap = parseFloat(v.querySelector(".prod_ac_price").textContent.trim()) / 100;
        
        if (gp) {
          gp.textContent = `$${(ap / vp).toFixed(2)}/oz`;
        }
      });
    }
  }
  
  // Initialize on page load
  initializePricePerGram();
  
  // Re-initialize after a short delay to ensure all elements are loaded
  setTimeout(initializePricePerGram, 500);
  
  typeof showBadge === "function" && showBadge();
});


// function showBadge() {
//   const variant = document.querySelectorAll('.meta_connected_prd');
//     variant.forEach(elt => {
//       const prod_badge = elt.querySelector('.prod_badge');
//     const prod_var_wt = elt.querySelector('.prod_var_price').textContent; 
//     console.log("Variant weight: ", prod_var_wt);

//     if (prod_var_wt == '100g') {
//       console.log("Badge: ", prod_badge);
//       prod_badge.style.display = 'flex';
//     }
//   })
// }

// document.addEventListener("DOMContentLoaded", function () {
//   const variants = document.querySelectorAll('.meta_connected_prd');
  
//   variants.forEach(variant => {
//     const prod_var_price = parseInt(variant.querySelector('.prod_var_price').textContent.trim()); 
//     console.log("Wt :",  prod_var_price);
       
//     const prod_price = variant.querySelector('.prod_price_gram');
//     const prod_ac_price = parseInt(variant.querySelector('.prod_ac_price').textContent.trim() / 100);
//     const price_per_gr = prod_ac_price / prod_var_price;
    
//     prod_price.textContent = `$${price_per_gr.toFixed(2)} / g`;
//   });

//   showBadge();
// });



(function () {
    // Gallery sticky video
    document.querySelectorAll('.e-sticky-thumb-video').forEach(container => {
        const closeBtn = container.querySelector('.e-sticky-thumb-video button');
        const video = container.querySelector('video');
        let isExpanded = false;
        let resizeRaf = null;

        if (video) {
            video.muted = true;
            const autoplay = () => {
                const p = video.play();
                if (p && typeof p.then === 'function') p.catch(() => {});
            };
            if (video.readyState >= 1) {
                autoplay();
            } else {
                video.addEventListener('loadedmetadata', autoplay, { once: true });
            }
        }

        const resetView = () => {
            isExpanded = false;
            container.classList.remove('expanded');
            if (video) {
                video.muted = true;
            }
        };

        container.addEventListener('click', (e) => {
            if (closeBtn && (e.target === closeBtn || closeBtn.contains(e.target))) return;
            isExpanded = !isExpanded;
            container.classList.toggle('expanded', isExpanded);
            if (video) {
                video.muted = !isExpanded;
                if (isExpanded) {
                    const p = video.play();
                    if (p && typeof p.then === 'function') p.catch(() => {});
                }
            }
        });

        if (closeBtn) {
            closeBtn.addEventListener('click', (e) => {
                e.stopPropagation();
                if (video) video.pause();
                container.style.display = 'none';
            });
        }

        const onResize = () => {
            if (resizeRaf) cancelAnimationFrame(resizeRaf);
            resizeRaf = requestAnimationFrame(resetView);
        };

        window.addEventListener('resize', onResize);
        window.addEventListener('orientationchange', onResize);
    });
})();